import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { map } from "rxjs/operators";
import { SchemaLevel } from "src/core/backend/controllers";
import { HierarchyCacheService } from "src/modules/shared/services/hierarchy-cache.service";
import { UserStateService } from "src/shared/services/user-state.service";

import { SharedModule } from "#modules/shared/shared.module";

@Component({
  selector: "app-pages-nav",
  templateUrl: "./pages-nav.component.html",
  styleUrls: ["./pages-nav.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class PagesNavComponent {
  private readonly hierarchyCacheService = inject(HierarchyCacheService);
  private readonly userStateService = inject(UserStateService);

  readonly pages$ = this.hierarchyCacheService.getFirstNavNodeByName(SchemaLevel.WebPages).pipe(map((node) => node?.children));
  readonly isEditor$ = this.userStateService.isEditor$;
}
